import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { EnvironmentService } from '@app/core/services/environment.service';
import { Observable } from 'rxjs';

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
});

@Injectable({
  providedIn: 'root'
})

export class CreateFormElementTypeService {

  constructor(private http: HttpClient, private envService: EnvironmentService) { }

  createFormElementType(formData: any): Observable<any> {
    return this.http.post<any>(`${this.envService.env.apiUrl}${api_routes.METADATA}/${api_routes.FORM_ELEMENT_TYPES}`, formData, {
      headers: headers
    })
  }
}
